<template>
  <el-checkbox :label="label" :value="value" :true-value="trueValue" :false-value="falseValue" :disabled="disabled" :border="border" :size="size" :name="name" :checked="checked"
    :indeterminate="indeterminate" :validate-event="validateEvent" :tabindex="tabindex" :id="id" :controls="controls"
    :aria-controls="ariaControls" @change="change">
    <slot v-if="!soltText"></slot>
    <template v-else>
      {{ i18nConfig(soltText) }}
    </template>
  </el-checkbox>
</template>

<script>
import { i18nConfig } from '@/utils/ruoyi'
import { reactive, toRefs, getCurrentInstance, onMounted } from 'vue'
export default {
  name: "gljy-checkbox",
  emits: ["change", "update:value"],
  props: {
    value: [String, Number, Boolean, Object],
    label: String,
    trueValue: [String, Number],
    falseValue: [String, Number],
    trueLabel: [String, Number],
    falseLabel: [String, Number],
    disabled: Boolean,
    border: Boolean,
    size: String,
    name: String,
    checked: Boolean,
    indeterminate: Boolean,
    validateEvent: Boolean,
    tabindex: [String, Number],
    id: String,
    controls: String,
    ariaControls: String,
  },
  setup(props, context) {
    const { proxy } = getCurrentInstance();
    const datas = reactive({
      soltText: undefined,
      i18nConfig: i18nConfig
    })

    const methods = {
      change(value) {
        context.emit("update:value", value);
        context.emit("change", value);
      }
    }

    onMounted(() => {
      nextTick(() => {
        try {
          const slotDefault = proxy.$slots?.default();
          if (slotDefault.length == 1 && typeof slotDefault[0].type == "symbol") {
            datas.soltText = slotDefault[0].children;
          }
        } catch (e) {
        }
      })
    })


    return {
      ...toRefs(datas),
      ...methods
    }
  }
}
</script>

<style lang="scss" scoped></style>